import http from 'helpers/requests';

// verifier-firm-foundation phase 2 — the firm's own membership and profile.
const unwrap = (promise) => promise.then((response) => response.data);

export const claimVerifierFirm = () => unwrap(http.post('/verifier-firms/claim', {}));
export const fetchMyFirm = () => unwrap(http.get('/verifier-firms/me'));
export const setupMyFirm = (body) => unwrap(http.post('/verifier-firms/me/setup', body));
export const updateMyFirm = (body) => unwrap(http.patch('/verifier-firms/me', body));
export const removeFirmMember = (clerkUserId) =>
  unwrap(http.remove(`/verifier-firms/me/members/${encodeURIComponent(clerkUserId)}`));
export const setFirmMemberRole = (clerkUserId, role) =>
  unwrap(http.patch(`/verifier-firms/me/members/${encodeURIComponent(clerkUserId)}`, { role }));
export const unblockFirmEmail = (email) =>
  unwrap(http.remove(`/verifier-firms/me/blocked/${encodeURIComponent(email)}`));
export const fetchFirmTeam = () => unwrap(http.get('/verifier-firms/me/members'));
export const fetchAccreditationBodies = () =>
  unwrap(http.get('/verifier-firms/accreditation-bodies'));
